import { render, staticRenderFns } from "./sena.vue?vue&type=template&id=8143accc&scoped=true"
import script from "./sena.vue?vue&type=script&lang=js"
export * from "./sena.vue?vue&type=script&lang=js"
import style0 from "./sena.vue?vue&type=style&index=0&id=8143accc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8143accc",
  null
  
)

export default component.exports